export default class CustomYoutube {

    constructor() {
        this.addEvents();
        this.addAnchors();
        this.popupExit()
    }

    addEvents() {
        const youtubePlay = document.querySelectorAll('.custom-youtube');
        const youtubePlay_review = document.querySelectorAll('.youtubeLink');
        const youtubePlayReserve = document.querySelectorAll('.bt_case__item--youtube');
        const youtubePlayReserveReview = document.querySelectorAll('.openYoutube-case');
        window.addEventListener('load', e => {
            if(youtubePlay) {
                youtubePlay.forEach((element) => {
                    const youtube = element.querySelector('.elementor-heading-title');
                    if (youtube) {
                        element.setAttribute('data-youtube', youtube.innerHTML.trim());
                        element.querySelector('div').remove();
                        element.addEventListener('click', () => {
                            const youtubeLink = element.getAttribute('data-youtube') ? this.youtube_parser(element.getAttribute('data-youtube')) : '';
                            this.generatePopup(youtubeLink);
                        });
                    } else {
                        element.remove();
                    }
                });
            }

            if(youtubePlay_review) {
                youtubePlay_review.forEach((element) => {
                    const youtube = element.querySelector('.jet-listing-dynamic-field__content');
                    if (youtube) {
                        let parent = element.closest('.case-studies-slide');
                        parent.querySelector('.openYoutube-case').setAttribute('data-youtube', youtube.innerHTML.trim());
                    }
                    element.remove();
                });
            }

            if(youtubePlayReserveReview){
                youtubePlayReserveReview.forEach((element) => {
                    element.addEventListener('click', () => {
                        const youtubeLink = element.getAttribute('data-youtube') ? this.youtube_parser(element.getAttribute('data-youtube')) : '';
                        this.generatePopup(youtubeLink);
                    });
                });
            }

            if(youtubePlayReserve){
                youtubePlayReserve.forEach((element) => {
                    element.addEventListener('click', () => {
                        const youtubeLink = element.getAttribute('data-youtube') ? this.youtube_parser(element.getAttribute('data-youtube')) : '';
                        this.generatePopup(youtubeLink);
                    });
                });
            }
        });

        const that = this;

        $('body').on('click', '.resources__posts--popup', function (e){
            e.preventDefault();
            let link = $(this).attr('data-video') ? that.youtube_parser($(this).attr('data-video')) : '';
            const popup = document.querySelector('.youtube-popup');
            if(link) {
                const iframe = document.createElement("iframe");
                iframe.src = 'https://www.youtube.com/embed/'+link+'?rel=0&autoplay=1';
                iframe.setAttribute('allowfullscreen', 'allowfullscreen');
                popup.querySelector('.youtube-popup__iframe').appendChild(iframe);
                popup.classList.add('active');
            }
        })
    }

    addAnchors(){
        const youtubePlayReserve = document.querySelectorAll('.youtube_link--reserve');
        if (!youtubePlayReserve) return;
        window.addEventListener('load', e => {
            youtubePlayReserve.forEach((element) => {
                const youtube = element.querySelector('a');
                if(youtube) {
                    youtube.addEventListener('click', (el)=> {
                        el.preventDefault();
                        const youtubeLink = youtube.getAttribute('href') ? this.youtube_parser(youtube.getAttribute('href')) : '';
                        this.generatePopup(youtubeLink);
                    });
                }
            });
        });

    }

    generatePopup(youtubeLink){
        const popup = document.querySelector('.success-popup');
        if(youtubeLink) {
            const iframe = document.createElement("iframe");
            iframe.src = 'https://www.youtube.com/embed/'+youtubeLink+'?rel=0&autoplay=1';
            iframe.setAttribute('allowfullscreen', 'allowfullscreen');
            popup.querySelector('.success-popup__iframe').appendChild(iframe);
            popup.classList.add('active');
        }
    }

    popupExit(){
        document.querySelectorAll('.success-popup .rgba, .success-popup__exit').forEach((element) => {
            element.addEventListener('click', ()=> {
                const popup = document.querySelector('.success-popup');
                popup.classList.remove('active');
                popup.querySelector('iframe').remove();
            })
        });
        document.querySelectorAll('.youtube-popup .rgba, .youtube-popup__exit').forEach((element) => {
            element.addEventListener('click', ()=> {
                const popup = document.querySelector('.youtube-popup');
                popup.classList.remove('active');
                popup.querySelector('iframe').remove();
            })
        });
    }

    youtube_parser(url){
        var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
        var match = url.match(regExp);
        return (match&&match[7].length==11)? match[7] : false;
    }
}
